import isObject from "../struct-events/is-object.js";

class ObjectValueTrackerLinker {
    constructor(valueTracker) {
        this._valueTracker = valueTracker;

        this._object = null;
        this._events = null;
        this._key = null;

        this._propertySetThis = this._propertySet.bind(this);
        this._propertyDeleteThis = this._propertyDelete.bind(this);
    }

    track(newObject, newEvents, newKey) {
        const oldObject = this._object;
        const oldEvents = this._events;
        const oldKey = this._key;

        if (newObject === oldObject && newEvents === oldEvents && newKey === oldKey) {
            return;
        }

        if (newObject) {
            if (!isObject(newObject)) {
                throw new Error("Invalid object type");
            }

            if (!isObject(newEvents)) {
                throw new Error("Specified an object without events");
            }

            const keyType = typeof newKey;
            const validKeyType = keyType === "string" || keyType === "symbol";
            if (!validKeyType) {
                throw new Error("Invalid key type (only string and symbol allowed)");
            }
        } else {
            if (newObject !== undefined && newObject !== null && newObject !== false) {
                throw new Error("Invalid object type");
            }

            if (newEvents !== undefined && newEvents !== null && newEvents !== false) {
                throw new Error("No object but specified events");
            }

            newObject = null;
            newEvents = null;
            newKey = null;
        }

        this._object = newObject;
        this._events = newEvents;
        this._key = newKey;

        if (oldObject) {
            oldEvents.unlisten("set", oldKey, this._propertySetThis);
            oldEvents.unlisten("delete", oldKey, this._propertyDeleteThis);
        }

        if (newObject && newKey in newObject) {
            this._valueTracker.setValue(newObject[newKey]);
        } else {
            this._valueTracker.deleteValue();
        }

        if (newObject) {
            newEvents.listen("set", newKey, this._propertySetThis);
            newEvents.listen("delete", newKey, this._propertyDeleteThis);
        }
    }

    _propertySet(object, key, oldValue, newValue) {
        this._valueTracker.setValue(newValue);
    }

    _propertyDelete(object, key, oldValue) {
        this._valueTracker.deleteValue();
    }
}

export default ObjectValueTrackerLinker;
